import { defineNuxtPlugin, useNuxtApp } from 'nuxt/app';

export default defineNuxtPlugin( () => {
  const nuxtApp = useNuxtApp();

  nuxtApp.hook('i18n:localeSwitched', ({ newLocale }) => {
    const { $api, $feApiNetwork } = nuxtApp;
    for (const api of [$api, $feApiNetwork]) {
      api.defaults.headers['Accept-Language'] = newLocale;
    }
  });
});
